import './style.scss';

export default {
  template: `<button class='btn crm-btn merge-contact-button'>{{$ctrl.text}}</button>`,
  bindings: {
    text: '@',
  },
};
